export class AsyncWorkerPool {
  private fileName: string;
  private numWorkers = 1;
  private workers = [];
  private queue = [];

  constructor(fileName: string, numWorkers=2) {
    this.fileName = fileName;
    this.numWorkers = numWorkers;
    this.initWorkers();
  }

  initWorkers() {
    const filePath = `${process.env.PUBLIC_URL}/workers/${this.fileName}`;

    for (let i=0; i<this.numWorkers; i++) {
      const worker = new Worker(filePath);
      this.workers.push(worker);
    }
  }

  postMessage(message: any, transfer: Transferable[] = null): Promise<any> {
    return new Promise(resolve => {
      this.queue.push({message, transfer, resolve});
      this.processQueue();
    });
  }

  /** @private */
  processQueue() {
    if (this.workers.length === 0) return;
    if (this.queue.length === 0) return;

    const worker = this.workers.shift();
    const {message, transfer, resolve} = this.queue.shift();

    worker.onmessage = event => {
      resolve(event.data);

      // Return worker to array
      this.workers.push(worker);

      // Process next item in queue
      this.processQueue();
    };

    worker.postMessage(message, transfer);
  }
}